import React, { useMemo } from 'react';
import { Navigation, Footer } from '../components/Navigation';
import usePageTitle from '../hooks/usePageTitle';

// Import album cover images
import futureShockCover from '../assets/images/covers/future-shock.jpg';
import scatterBrainedCover from '../assets/images/covers/scatter-brained.jpg';
import hazeOverTheHorizonCover from '../assets/images/covers/haze-over-the-horizon.jpg';
import triumphCover from '../assets/images/covers/triumph.jpg';
import storeLastNightCover from '../assets/images/covers/store-last-night.jpg';
import neverSeeYouLaterCover from '../assets/images/covers/never-see-you-later.jpg';
import itsAllInYourHeadCover from '../assets/images/covers/its-all-in-your-head.jpg';
import everythingSucksCover from '../assets/images/covers/everything-sucks.jpg';
import eatTheRichCover from '../assets/images/covers/eat-the-rich.jpg';
import lieDenyBlameAiCover from '../assets/images/covers/lie-deny-blame-ai.jpg';


const ReleasesPage = () => {
  usePageTitle('Releases | Solypsizm');
  // Updated release data with new titles and images
  const releases = useMemo(() => [
    {
      id: 11,
      title: "Future Shock",
      year: "2026",
      image: futureShockCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/68slocqmB0lu5LhVqjQAuY?si=af935c7b864748c0" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/future-shock/1883453179" },
        { name: "YouTube", link: "https://youtu.be/5n8o82pg5mk?si=dZpDHoquIABqV-JW" }
      ]
    },
    {
      id: 10,
      title: "Scatter Brained",
      year: "2026",
      image: scatterBrainedCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/3DqHjh51BpIF5Vlp6gZYfU?si=7fff9c0f383e4bf0" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/scatter-brained/1871017929" },
        { name: "YouTube", link: "https://youtu.be/8rrPu3JcUzY?si=t780bSp2Yx6S5-_6" }
      ]
    },
    {
      id: 9,
      title: "Haze over the Horizon",
      year: "2026",
      image: hazeOverTheHorizonCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/5CSm4i0gi1wiqPCi21EFC4?si=c7c0d89d055a419d" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/haze-over-the-horizon/1863780796" },
        { name: "YouTube", link: "https://youtu.be/0XK7dIyxv9I?si=o-XSiXpUTDCvuaFL" }
      ]
    },
    {
      id: 8,
      title: "Lie, Deny, and Blame A.I.",
      year: "2025",
      image: lieDenyBlameAiCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/59In6cKa234Wu5dpnc93fL?si=c528da7ed1a944d1" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/lie-deny-and-blame-a-i/1859072255" },
        { name: "YouTube", link: "https://youtu.be/0BkDS19AEx0?si=tgAzzypIrDCZk1db" }
      ]
    },
    {
      id: 2,
      title: "Eat the Rich",
      year: "2025",
      image: eatTheRichCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/27ChOplzNBS0scl3QPAc3U?si=a97e97ae631d4acb" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/eat-the-rich/1854880145" },
        { name: "YouTube", link: "https://youtu.be/EqBld_I5Pks?si=GW3cYsg6xC13Jjr4" }
      ]
    },
    {
      id: 3,
      title: "Everything Sucks",
      year: "2025",
      image: everythingSucksCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/393Jfhmurvxit7RDexuNua?si=a61bcb37e2ca4a69" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/everything-sucks/1848168303" },
        { name: "YouTube", link: "https://youtu.be/saMbT9G6Fug?si=ZC24JG3MjdyPOXLL" }
      ]
    },
    {
      id: 4,
      title: "It's all in your head",
      year: "2025",
      image: itsAllInYourHeadCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/0v78NsyapaNiXFn7tOLym2?si=448a591c9a1c4c44" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/its-all-in-your-head/1844208912" },
        { name: "YouTube", link: "https://youtu.be/kF3FzhlQpos?si=XEuAgfBOOYB8pPPa" }
      ]
    },
    {
      id: 5,
      title: "Never See You Later",
      year: "2025",
      image: neverSeeYouLaterCover,
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/7jXJcidwKpgyL5i1bNUp5X?si=d84b67eece1a48ea" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/never-see-you-later/1838362181" },
        { name: "YouTube", link: "https://youtu.be/l4FpE2xjhVk?si=Qa7-hEyzrnO5ch5h" }
      ]
    },
    {
      id: 6,
      title: "Store Last Night",
      image: storeLastNightCover,
      year: "2025",
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/73wLnVrVQ6eVxOwAmVDBka?si=c3d19c5d519d4fee" },
        { name: "Apple Music", link: "https://music.apple.com/us/song/store-last-night/1829599879" },
        { name: "YouTube", link: "https://youtu.be/LJz3H7jufr8?si=G53g-gT4Z76H2QNd" }
      ]
    },
    {
      id: 7,
      title: "triumph",
      image: triumphCover,
      year: "2025",
      platforms: [
        { name: "Spotify", link: "https://open.spotify.com/track/3i4sTEp8JCMVqNwRhDk8rf?si=3f655e4db2c2456e" },
        { name: "Apple Music", link: "https://music.apple.com/us/album/triumph-single/1818373372" },
        { name: "YouTube", link: "https://youtu.be/sioHjsE4UmQ?si=Tb_gHZpVmGuwY4Gp" }
      ]
    }
  ], []); // Empty dependency array means this memoized value is created once

  return (
    <div className="min-h-screen bg-charcoal text-white">
      <Navigation currentPage="releases" />

      {/* Hero Section */}
      <section className="electric-blizzard-bg pt-16 pb-8 md:pt-20 md:pb-10 relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 text-center z-10 relative">
          <h1 className="font-cinzel text-4xl sm:text-5xl md:text-6xl mb-6">Music Releases</h1>
          <p className="text-lg sm:text-xl">New releases every 4-6 weeks</p>
        </div>
      </section>

      {/* Releases Grid */}
      <section className="pt-4 pb-12 md:pt-6 md:pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {releases.map((release) => {
              const youtubeLink = release.platforms.find(p => p.name === "YouTube")?.link;
              const spotifyLink = release.platforms.find(p => p.name === "Spotify")?.link;
              const mainLink = youtubeLink || spotifyLink;
              const otherPlatforms = release.platforms.filter(p => p.name !== "YouTube");

              return (
                <div key={release.id} className="bg-charcoal-dark p-4 md:p-6 rounded-lg transition-all duration-300">
                  <a
                    href={mainLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group aspect-square mb-4 rounded shadow-lg overflow-hidden relative block cursor-pointer border-2 border-transparent hover:border-neon-blue transition-all duration-300"
                  >
                    <img
                      src={release.image}
                      alt={`${release.title} cover`}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
                    <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full border border-gray-800 z-10">
                      <span className="text-neon-blue text-xs font-bold tracking-widest">{release.year}</span>
                    </div>
                  </a>
                  <h3 className="font-body font-bold text-xl md:text-2xl mb-4 text-center">{release.title}</h3>

                  <a
                    href={mainLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full py-2 border border-neon-blue text-neon-blue hover:bg-neon-blue hover:text-white transition-colors rounded block text-center mb-4"
                  >
                    Listen Now
                  </a>

                  <div className="flex flex-wrap justify-center gap-4">
                    {otherPlatforms.map((platform, index) => (
                      <a
                        key={index}
                        href={platform.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs md:text-sm text-gray-400 hover:text-white cursor-pointer"
                      >
                        {platform.name}
                      </a>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Newsletter Section - Hidden for now
      <section className="py-12 md:py-16 px-4 bg-charcoal-dark">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-cinzel text-2xl md:text-3xl mb-6">Stay Updated</h2>
          <p className="mb-6 md:mb-8 text-base md:text-lg">Subscribe to our newsletter for exclusive content and early release notifications.</p>
          <div className="flex flex-col md::flex-row gap-4 justify-center">
            <input
              type="email"
              placeholder="Your email address"
              className="px-4 py-3 bg-charcoal border border-gray-700 rounded focus:outline-none focus:border-neon-blue w-full md:w-auto"
            />
            <button className="neon-button">Subscribe</button>
          </div>
        </div>
      </section>
      */}

      <Footer />
    </div>
  );
};

export default ReleasesPage;
